<!--
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  fxLayout="row"
  fxLayoutAlign="start center"
  class="nvc-black nvc-font-14px"
  *ngIf="isWidgetSource"
>
  <div class="nvc-margin-left" (click)="goToWidget()">
    <mat-icon class="fa fa-arrow-left"></mat-icon>
    <b class="sc-company-link ws-cursor-pointer">Back to Store</b>
  </div>
</div>
<div fxLayout="column" class="nvc-total" *ngIf="!selectionPreview">
  <div
    fxLayout="column"
    *ngIf="
      (this.router.url.includes('myorders') ||
        this.router.url.includes('quotations') ||
        this.router.url.includes('myaddresses') ||
        this.router.url.includes('privacy-policy') ||
        this.router.url.includes('appointments') ||
        this.router.url.includes('stores') ||
        this.router.url.includes('homePage') ||
        this.router.url.includes('my-company') ||
        this.router.url.includes('mywishlist') ||
        this.router.url.includes('notifications') ||
        this.router.url.includes('profile') ||
        this.router.url.includes('change-password')) &&
      !(
        this.router.url.includes('promolink') ||
        this.router.url.includes('boardGroupPromolink') ||
        this.router.url.includes('virtual-tryon') ||
        this.router.url.includes('3Dmodel')
      )
    "
    fxHide.gt-xs
  >
    <div *ngIf="!checkCompanyCreation()" class="ws-myorder-header">
      <app-side-nav></app-side-nav>
      <img
        class="nvc-whiteshop-logo"
        [ngClass]="isUserConsumer() ? '' : 'ws-cursor-pointer'"
        (click)="goToHome()"
        [src]="whiteShopLogo"
        alt=""
      />
    </div>
  </div>
  <app-header
    *ngIf="
      checkHeaderFooter() &&
      !isClickToCall.flag &&
      !(!slotService.isPanoramaLoaded && isCustomized)
    "
    [ngClass]="isHeaderSticky() ? 'nvs-header' : ''"
    fxFlex.lt-sm="10"
    fxFlex.gt-xs="20"
  ></app-header>
  <div
    id="nvc-body"
    [ngClass]="
      isPaddingApplied()
        ? isUserConsumer()
          ? isPromotionBooking
            ? 'nvc-body-promotion'
            : 'nvc-body-consumer'
          : 'nvc-body'
        : ''
    "
  >
    <router-outlet></router-outlet>
  </div>
  <div
    *ngIf="
      !isTop &&
      !this.router.url.includes('promolink') &&
      !this.router.url.includes('ARDialog')
    "
    (click)="scrollTop()"
    class="nvc-top-button"
  >
    <img
      class="nvc-arrow-upward"
      src="../assets/icons/arrow_upward.svg"
      alt="top"
    />
  </div>
  <app-footer
    *ngIf="checkHeaderFooter() && !isClickToCall.flag && !isMobileDevice()"
  ></app-footer>
  <app-footer
    *ngIf="checkMobileFooter() && !isClickToCall.flag"
    fxHide.gt-xs
  ></app-footer>
</div>
<div id="google_translate_element" style="display: none"></div>
<div
  *ngIf="isA2H"
  class="A2H"
  fxLayout="row"
  fxLayoutAlign="space-evenly center"
>
  <img class="A2HImage" src="../assets/icons/icon-128x128.png" alt="logo" />
  <span class="notranslate" i18n>Add whiteshop to Home</span>
  <button class="A2HButton notranslate" (click)="installPrompt()" i18n>
    Yes
  </button>
  <button class="A2HButton notranslate" (click)="close()" i18n>No</button>
</div>

<mat-icon
  *ngIf="!isARDialog"
  svgIcon="eyeIcon"
  class="ws-display-none"
></mat-icon>
<mat-icon
  *ngIf="!isARDialog"
  svgIcon="eyeSlashIcon"
  class="ws-display-none"
></mat-icon>

<div
  *ngIf="isLandscape"
  class="turn"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <p class="notranslate" i18n>
    Please turn your device to portrait mode for better experience.
  </p>
</div>
<div
  *ngIf="orderDashboard"
  class="dashboard"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <p class="notranslate ws-loading redirect-margin" i18n>Redirecting...</p>
</div>

<ng-http-loader
  *ngIf="
    !localStorageService.isLoaderDisabled &&
    !isCustomized &&
    !slotService.is3dBoardLoading &&
    !(isTargetUrl && !promoLinkAuthorizationService.selectionBoardLoaded)
  "
  [backdrop]="true"
  [opacity]="1"
  [backgroundColor]="'#008000'"
  [debounceDelay]="0"
  [extraDuration]="300"
  [minDuration]="500"
  [entryComponent]="loader"
  [filteredHeaders]="['Authorization']"
  [filteredUrlPatterns]="['createExcelReport', 'getInventorySnapshop']"
>
</ng-http-loader>
<div
  *ngIf="
    !isCustomized &&
    !slotService?.isPanoramaLoaded &&
    (slotService.is3dBoardLoading ||
      (isTargetUrl && !promoLinkAuthorizationService.selectionBoardLoaded))
  "
  class="sc-3d-board-loader"
  fxLayout="row"
  fxLayoutAlign="center center"
>
  <app-loader></app-loader>
</div>
<audio #audio loop>
  <source src="assets/no-audio.mp3" type="audio/mpeg" *ngIf="audioActive" />
</audio>
<div
  *ngIf="
    !slotService.isPanoramaLoaded &&
    !slotService.isTDLoaded &&
    isCustomized &&
    isFontLoaded &&
    !is3DUrl &&
    this.router.url.includes('promolink') &&
    !slotService.websitePromolinkCB
  "
  class="nvc-top-0 nvc-position-absolute nvc-width-hundred nvc-height-hundred"
  [ngClass]="[
    this.slotService.isFooterEnabled ? 'nvc-height-80' : '',
    !this.slotService.isSTLPromolink ? 'nvc-style' : ''
  ]"
  fxLayoutAlign="center center"
  fxLayout
>
  <div
    class="nvc-width-hundred nvc-position-absolute nvc-top"
    *ngIf="!slotService.isThreeDEntered && !slotService.isPanoramaLoaded"
  >
    <h2 class="nvc-font-style">Please wait while the screen is loading...</h2>
  </div>
</div>
